import './../products/products.scss'
import { EyeOutlined, 
  RedoOutlined,
  WalletOutlined,
  FieldTimeOutlined,
  HistoryOutlined, CalendarOutlined, WhatsAppOutlined, UserOutlined, ArrowDownOutlined, ArrowUpOutlined, CloseCircleOutlined, CheckCircleOutlined, DollarOutlined, DeleteOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Button, Space, Popover, Popconfirm, Tag, Tabs, Modal } from 'antd';
import axios from 'axios';
import { Link } from 'react-router-dom';
import config from '../../config';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import CountUp from 'react-countup';
import moment from 'moment';
import DetteJour from './DetteJour';
import DetteJour7 from './DetteJour7';
import DetteJours30 from './DetteJours30';
import DetteOne from './DetteOne';
import { toast } from 'react-toastify';
import canSeeFinance from '../../utils/canSeeFinance';
import {
  NdoePage, NdoePageHeader, NdoeToolbar, NdoeActionButton,
  NdoeResponsiveTable, NdoeStats, NdoeStatCard,
  NdoeDataCard, NdoeStatusBadge, NdoeRecherche,
  filtreTexte, optionsDe, compterActifs,
} from '../../components/ndoe';

const Dette = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [open, setOpen] = useState(false);
    const [recent, setRecent] = useState([]);
    const [recentPaiement, setRecentPaiement] = useState([]);
    const [idClient, setIdClient] = useState({});
    const user = useSelector((state) => state.user?.currentUser);
    // Recherche unifiée : la période est un CHARGEMENT serveur (elle remplace le
    // jeu de données), les autres critères filtrent ce qui est déjà à l'écran.
    const [statut, setStatut] = useState(undefined);
    const [debut, setDebut] = useState('');
    const [fin, setFin] = useState('');
    const [chargePeriode, setChargePeriode] = useState(false);


      const fetchDette = async () => {
        try {
          const { data } = await axios.get(`${DOMAIN}/api/vente/vente/dette`);
          setData(data);
          setLoading(false);
        } catch (error) {
          console.log(error);
        }
      };

      const fetchPaiement = async () => {
        try {
          const { data } = await axios.get(`${DOMAIN}/api/vente/vente/dettePaiement`);
          setRecentPaiement(data);
        } catch (error) {
          console.log(error);
        }
      };

      const fetchRapport = async () => {
        try {
          const { data } = await axios.get(`${DOMAIN}/api/vente/vente/detteRapport`);
          setRecent(data);
        } catch (error) {
          console.log(error);
        }
      };

      const handleDelete = async (id) => {
        try {
          await axios.delete(`${DOMAIN}/api/vente/vente/dette/${id}`);
          toast.success('Dette supprimée avec succès');
          fetchDette();
          fetchRapport();
          fetchPaiement();
        } catch (err) {
          toast.error("Erreur lors de la suppression");
        }
      };

      // Période : rechargement serveur (mêmes bornes que l'ancien panneau
      // « Filtres avancés », qui ne proposait QUE ça). Sans bornes, on revient
      // à la liste complète plutôt que d'envoyer des paramètres vides.
      const chercherPeriode = async () => {
        setChargePeriode(true);
        try {
          const url = debut && fin
            ? `${DOMAIN}/api/vente/vente/dette?start_date=${debut}&end_date=${fin}`
            : `${DOMAIN}/api/vente/vente/dette`;
          const { data } = await axios.get(url);
          setData(data);
        } catch (error) {
          toast.error('Impossible de charger les dettes sur cette période.');
        } finally {
          setChargePeriode(false);
        }
      };

      // ⑤ Actualisation sans rechargement de page : on refetch la liste + les KPI.
      const Rafraichir = () => {
        fetchDette();
        fetchRapport();
        fetchPaiement();
      };

      const columns = [
        { title: '#', dataIndex: 'id', key: 'id', render: (text, record, index) => index + 1},
        {
          title: 'Code',
          dataIndex: 'id_commande',
          key: 'id_commande',
          render: (text, record) => (
            <Tag color="blue">{`${new Date().getFullYear().toString().substring(2)}${record.id_shop.toString().padStart(2, '0')}${record.id_commande.toString().padStart(4, '0')}`}</Tag>
          ),
        },
        {
          title: 'NomDelaClient',
          dataIndex: 'nom',
          key: 'nom',
          render : (text,record)=>(
            <div onClick={()=> handleOk(record.id_client)} style={{cursor: 'pointer'}}>
            <Popover title={`Voir les détails de ${text}`} trigger="hover">
              <Tag color={'blue'}>
                <UserOutlined style={{ marginRight: "5px" }} />
                {text}
              </Tag>
            </Popover>
            </div>
          )
        },
        {
          title: 'Telephone',
          dataIndex: 'telephone',
          key: 'email',
          render: (text) => (
            <Popover content="Discutez avec lui sur WhatsApp" placement="top">
            <Tag
              onClick={() => window.open(`https://wa.me/${text}`, '_blank')}
              color="green"
              style={{ cursor: 'pointer' }}
            >
              <WhatsAppOutlined style={{ color: 'green', marginRight: '5px' }} />
              {text}
            </Tag>
          </Popover>
          ),
        },
          {
            title: 'Montant facture',
            dataIndex: 'montant_convenuV',
            key: 'montant_convenu',
            sorter: (a, b) => a.montant_convenuV - b.montant_convenuV,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => (
              <Tag color="blue" icon={<DollarOutlined />}>
                {record.montant_convenuV.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </Tag>
            ),
          },
        {
          title: 'Montant payé',
          dataIndex: 'montant_payeV',
          key: 'montant_payeV',
          sorter: (a, b) => a.montant_payeV - b.montant_payeV,
          sortDirections: ['descend', 'ascend'],
          render: (text, record) => (
            <Tag color="blue" icon={<DollarOutlined />}>
              {record.montant_payeV.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              })}
            </Tag>
          ),
        },
        {
          title: 'Nbre dette',
          dataIndex: 'nbre_dette',
          key: 'nbre_dette',
          sorter: (a, b) => a.nbre_dette - b.nbre_dette,
          sortDirections: ['descend', 'ascend'],
          render: (nbre_dette) => (
            <Tag color={nbre_dette > 0 ? 'green' : 'red'} icon={<DollarOutlined />}>
              {nbre_dette}
            </Tag>
          ),
        },
          {
            title: 'Montant restant',
            dataIndex: 'montant_restant',
            key: 'montant_restant',
            sorter: (a, b) => a.montant_restant - b.montant_restant,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => {
              let icon;

              if (record.montant_restant > 0) {
                icon = <ArrowUpOutlined />;
              } else if (record.montant_restant < 0) {
                icon = <ArrowDownOutlined />;
              } else {
                icon = null;
              }

              return (
                <Tag color={record.montant_restant === 0 ? 'green' : 'red'} icon={icon}>
                  {record.montant_restant.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                  })}
                </Tag>
              );
            },
          },
          {
            title: 'Date',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text) => {
              const formattedDate = format(new Date(text), 'dd-MM-yyyy');
              return <Tag color={'blue'} icon={<CalendarOutlined />}>
                      {formattedDate}
                     </Tag>;
            },
        },
          {
            title: 'Statut',
            dataIndex: 'statut',
            key: 'statut',
            render: (text) => (
              <Tag color={text === 'Validé' ? 'green' : 'red'}>
                {text === 'Validé' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                &nbsp; {text }
              </Tag>
            ),
          },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (

              <Space size="middle">
                <Popover title={`Voir les ventes à crédit de Mme ${record.nom}`} trigger="hover">
                    <Link onClick={()=> handleOk(record.id_client)}>
                      <Button icon={<EyeOutlined />} style={{ color: 'blue' }} />
                    </Link>
                  </Popover>
                {user?.role === 'admin' &&
                <Popover title="Supprimer" trigger="hover">
                  <Popconfirm
                    title="Êtes-vous sûr de vouloir supprimer?"
                    onConfirm={() => handleDelete(record.id_dette)}
                    okText="Oui"
                    cancelText="Non"
                  >
                    <Button icon={<DeleteOutlined />} style={{ color: 'red' }} />
                  </Popconfirm>
                </Popover>}
              </Space>
            ),
          },
      ];

      const FINANCE_COLUMN_KEYS = ['montant_convenu', 'montant_payeV', 'montant_restant'];
      const visibleColumns = canSeeFinance(user)
        ? columns
        : columns.filter((col) => !FINANCE_COLUMN_KEYS.includes(col.key));

      useEffect(() => {
        fetchDette();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [DOMAIN]);

      useEffect(() => {
        fetchPaiement();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [DOMAIN]);

      useEffect(() => {
        fetchRapport();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [DOMAIN]);


    const handleOk = async (e) => {
      setOpen(true)
      setIdClient(e)
    };

  // Code lisible AA + shop(2) + commande(4) (miroir de la colonne "Code").
  // Défini AVANT le filtrage : la zone libre s'en sert, et une const déclarée
  // plus bas serait dans sa zone morte au moment du rendu.
  const formatCode = (record) => {
    try {
      return `${new Date().getFullYear().toString().substring(2)}${record.id_shop.toString().padStart(2, '0')}${record.id_commande.toString().padStart(4, '0')}`;
    } catch {
      return record?.id_commande ?? '—';
    }
  };

  // Zone libre : TOUS les critères affichés à la fois, plusieurs mots = ET.
  // Avant, elle ne balayait QUE le nom de la cliente — taper un numéro de
  // commande, un code ou un téléphone ne donnait rien, sans que rien ne le dise.
  // Les MONTANTS sont volontairement absents : ils vivent derrière
  // canSeeFinance ; les rendre cherchables les exposerait indirectement.
  const filteredData = (data || [])
    .filter(filtreTexte(searchValue, [
      'nom', 'telephone', 'statut',
      (d) => d.id_commande,
      (d) => formatCode(d),
    ]))
    .filter((d) => !statut || String(d.statut) === statut);

  const actifs = compterActifs(searchValue, statut);

  const money = (v) =>
    Number(v || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

  // Carte mobile (remplace une ligne de tableau). Les montants restent DERRIÈRE
  // canSeeFinance(user) — même garde que visibleColumns / FINANCE_COLUMN_KEYS.
  const renderDetteCard = (record) => {
    const isValide = record.statut === 'Validé';
    const metrics = [{ value: record.nbre_dette, label: 'nbre dette' }];
    if (canSeeFinance(user)) {
      metrics.unshift(
        { value: money(record.montant_convenuV), label: 'facture' },
        { value: money(record.montant_payeV), label: 'payé' },
        { value: money(record.montant_restant), label: 'restant' },
      );
    }
    const phone = record.telephone;
    const actions = [
      <NdoeActionButton key="v" size="sm" variant="ink" icon={<EyeOutlined />} onClick={() => handleOk(record.id_client)}>Voir</NdoeActionButton>,
      phone && <NdoeActionButton key="w" size="sm" variant="secondary" icon={<WhatsAppOutlined />} as="a" href={`https://wa.me/${String(phone).replace(/[^0-9]/g, '')}`} target="_blank" rel="noreferrer">WhatsApp</NdoeActionButton>,
      user?.role === 'admin' && (
        <Popconfirm key="d" title="Êtes-vous sûr de vouloir supprimer?" onConfirm={() => handleDelete(record.id_dette)} okText="Oui" cancelText="Non">
          <NdoeActionButton size="sm" variant="danger" icon={<DeleteOutlined />}>Suppr.</NdoeActionButton>
        </Popconfirm>
      ),
    ].filter(Boolean);

    return (
      <NdoeDataCard
        title={record.nom}
        subtitle={`${formatCode(record)}${record.created_at ? ' · ' + format(new Date(record.created_at), 'dd-MM-yyyy') : ''}`}
        badge={<NdoeStatusBadge kind="custom" tone={isValide ? 'ok' : 'danger'} label={record.statut} />}
        metrics={metrics}
        onClick={() => handleOk(record.id_client)}
        actions={actions}
      />
    );
  };

  // ----- Onglet "Dettes" (liste + filtres) -----
  const tabDettes = (
    <>
      <NdoeRecherche
        q={searchValue}
        onQ={setSearchValue}
        placeholder="Cliente, téléphone, n° de commande, code, statut…"
        periode={{ debut, fin }}
        onPeriode={(d, f) => { setDebut(d); setFin(f); }}
        onChercher={chercherPeriode}
        chargement={chargePeriode}
        facettes={[{
          cle: 'statut',
          placeholder: 'Statut',
          options: optionsDe(data, 'statut'),
          valeur: statut,
          onChange: setStatut,
          largeur: 160,
        }]}
        actifs={actifs}
        onEffacer={() => { setSearchValue(''); setStatut(undefined); }}
        resume={`${filteredData.length} sur ${data?.length || 0} dette${(data?.length || 0) > 1 ? 's' : ''}`}
      />
      <NdoeToolbar>
        <NdoeActionButton variant="secondary" icon={<RedoOutlined />} onClick={Rafraichir}>
          Actualiser
        </NdoeActionButton>
      </NdoeToolbar>

      {/* L'ancien panneau « Filtres avancés » (DetteSelect) est retiré : il ne
          proposait qu'une plage de dates, désormais portée par la barre de
          recherche. Deux outils au nom voisin, c'est ce qui égarait. */}

      <NdoeResponsiveTable
        data={filteredData}
        columns={visibleColumns}
        rowKey="id_dette"
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={{ pageSize: 10 }}
        renderCard={renderDetteCard}
        empty={{ icon: '💳', title: 'Aucune dette', text: 'Ajustez la recherche ou les filtres.' }}
      />

      <Modal title="" centered open={open} onCancel={() => setOpen(false)} width={1150} footer={[]}>
        <DetteOne idClients={idClient} />
      </Modal>
    </>
  );

  const tabItems = [
    {
      key: "0",
      label: (
        <>
          <WalletOutlined />Dettes
        </>
      ),
      children: tabDettes,
    },
    {
      key: "1",
      label: (
        <>
          <CalendarOutlined />Dettes du jour
        </>
      ),
      children: <DetteJour />,
    },
    {
      key: "2",
      label: (
        <>
          <FieldTimeOutlined />Dettes des 7 derniers jours
        </>
      ),
      children: <DetteJour7 />,
    },
    {
      key: "3",
      label: (
        <>
          <HistoryOutlined />Dettes des 30 derniers jours
        </>
      ),
      children: <DetteJours30 />,
    },
  ];

  return (
    <NdoePage>
      <NdoePageHeader
        eyebrow="Finance"
        title="Liste des ventes à crédit"
        subtitle={
          recent[0]?.date_derniere_dette
            ? `Ventes à crédit · du ${moment(recent[0]?.date_derniere_dette).format('DD-MM-YYYY')} au ${moment(recent[0]?.date_plus_recente).format('DD-MM-YYYY')}`
            : 'Gérer vos ventes à crédit'
        }
      />

      <NdoeStats>
        {canSeeFinance(user) && (
          <NdoeStatCard gold label="Payé aujourd'hui" value={<><CountUp end={recentPaiement[0]?.montant || 0} /> $</>} />
        )}
        <NdoeStatCard label="Clients payeurs (jour)" value={<CountUp end={recentPaiement[0]?.nombre_clients || 0} />} />
        {canSeeFinance(user) && (
          <NdoeStatCard gold label="Montant dû" value={<><CountUp end={recent[0]?.montant_total_restant || 0} /> $</>} />
        )}
        <NdoeStatCard label="Débiteurs enregistrés" value={<CountUp end={recent[0]?.nombre_total_clients_dette || 0} />} />
        <NdoeStatCard label="Crédit en cours" value={<CountUp end={recent[0]?.nombre_dettes_encours || 0} />} />
      </NdoeStats>

      <Tabs type="card" items={tabItems} />
    </NdoePage>
  )
}

export default Dette
